import React from "react";
import { media } from "./theme";
import { useMedia } from "react-use";

const MaintenancePage = () => {
  const isDesktop = useMedia(media.lg);
  return (
    <img
      className={"w-100"}
      src={
        isDesktop
          ? "allodedicace_page_maintenance_desktop.png"
          : "/allodedicace_page_maintenance_mobile.png"
      }
      alt="maintenance soon image"
    />
  );
};

export default MaintenancePage;
